import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { SPORTS } from "@/lib/content";

export default function Footer() {
  return (
    <footer className="border-t border-smasher-gold/15 bg-black mt-16" data-testid="site-footer">
      <div className="max-w-[1500px] mx-auto px-6 py-12 grid gap-10 md:grid-cols-4">
        <div className="space-y-4">
          <Logo />
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
            Sportsbook Smasher isn't about blindly placing bets. It's about understanding the game, understanding the
            wager, doing the research, and making informed decisions.
          </p>
        </div>
        <div>
          <div className="font-heading font-bold tracking-widest text-smasher-gold text-sm mb-4">SPORTS</div>
          <ul className="space-y-2 text-sm text-slate-400">
            {SPORTS.map((s) => (
              <li key={s.key}><Link to={`/${s.key}`} className="hover:text-smasher-gold">{s.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <div className="font-heading font-bold tracking-widest text-smasher-gold text-sm mb-4">LEARN</div>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/education" className="hover:text-smasher-gold">Betting Education</Link></li>
            <li><Link to="/strategy" className="hover:text-smasher-gold">The Smasher Strategy</Link></li>
            <li><Link to="/ebook" className="hover:text-smasher-gold">The Ebook</Link></li>
            <li><Link to="/news" className="hover:text-smasher-gold">Latest News</Link></li>
            <li><Link to="/responsible" className="hover:text-smasher-gold">Responsible Wagering</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-heading font-bold tracking-widest text-smasher-gold text-sm mb-4">COMPANY</div>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/about" className="hover:text-smasher-gold">About</Link></li>
            <li><Link to="/membership" className="hover:text-smasher-gold">Membership</Link></li>
            <li><Link to="/leaderboard" className="hover:text-smasher-gold">Leaderboard</Link></li>
            <li><Link to="/login" className="hover:text-smasher-gold">Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-[1500px] mx-auto px-6 py-6 text-xs text-slate-500 space-y-2">
          <p>
            <span className="text-slate-300 font-bold">21+.</span> Sports betting involves risk. No strategy guarantees a
            winning wager. Only wager what you can afford to lose. Gambling problem? Call 1-800-GAMBLER. Performance
            figures shown are illustrative; past results do not guarantee future outcomes. News summaries are for
            informational and educational purposes only.
          </p>
          <p className="text-slate-400" data-testid="footer-hard-work">Every pick, stat breakdown and news brief on Sportsbook Smasher is researched and written by our own team. We put in the work every day so you can bet smarter.</p>
          <p className="text-slate-600">© {new Date().getFullYear()} Sportsbook Smasher. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
